<template>
    <div>
        <v-row v-if="draggablex == true">
            <v-col cols="9" class="text-right">
                <label>
                    <gmap-autocomplete
                        :value="search"
                        ref="mapauto"
                        style="width: 100%; background-color: #ffff"
                        @keyup.enter="usePlace"
                        @place_changed="setPlace"
                    >
                    </gmap-autocomplete>
                </label>
            </v-col>
            <v-col cols="2" class="mr-1">
                <v-btn
                    block
                    small
                    class="ml-2 mb-1"
                    color="primary"
                    @click="usePlace"
                    >Search</v-btn
                >
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <gmap-map
                    :center="center"
                    ref="map2"
                    id="map2"
                    :zoom="18"
                    style="width: 100%; height: 500px"
                >
                    <gmap-marker
                        @dragend="updateMaker"
                        :position="center"
                        :clickable="true"
                        :draggable="draggablex"
                        @click="center = center"
                    >
                    </gmap-marker>
                </gmap-map>
            </v-col>
            <v-col cols="12" md="6">
                <gmap-map
                    ref="pano"
                    id="pano"
                    :zoom="18"
                    style="width: 100%; height: 500px"
                >
                </gmap-map>
            </v-col>

            <v-col cols="12" md="6" v-if="draggablex == true">
                <v-row v-if="chk_poi == true">
                    <v-col cols="12">
                        <p v-if="form_poi.name != '' && form_poi.name != null">
                            <span class="fix-das-bbb">Name : </span>
                            <span class="fix-das-bb">
                                {{ form_poi.name }}
                            </span>
                        </p>
                        <p class="mar-t-10">
                            <span class="fix-das-bbb">Address : </span>
                            <span class="fix-das-bb">
                                {{ form_poi.address }}
                            </span>
                        </p>
                    </v-col>
                    <v-col cols="12" class="mar-t-20">
                        <v-textarea
                            outlined
                            label="Reason.. เหตุผลที่เปลี่ยนพิกัด"
                            v-model="form_poi.remark"
                            required
                        ></v-textarea>
                    </v-col>
                    <v-col cols="12" class="mar-t-30">
                        <v-btn
                            @click="save_poi()"
                            :disabled="
                                form_poi.remark == '' || form_poi.remark == null
                            "
                            block
                            class="success"
                            >Save</v-btn
                        >
                    </v-col>
                </v-row>
            </v-col>
            <v-col
                cols="12"
                md="6"
                v-if="draggablex == true && chk_poi == true"
                align-self="center"
            >
                <b class="red--text font-fix-16"
                    >ถ้า KM = 0 หรือ มีการเปลี่ยนตำแหน่ง หรือ ปรับเปลี่ยนตำแหน่ง
                    Mark GPS ใหม่</b
                ><br />
                <b class="red--text font-fix-16"
                    >ให้ไปขยับเส้นทาง(Route) เพื่อให้ระบบคำนวนระยะทางใหม่</b
                ><br /><br /><br />
                <b class="red--text font-fix-16"
                    >กดดู VDO ตัวอย่างได้ที่ปุ่ม ? (ปุ่มอยู่มุมขวาล่าง)</b
                >

                <!--  -->
            </v-col>
        </v-row>
        <v-col cols="12" class="text-right">
            <v-btn
                fab
                fixed
                align-self-end
                bottom
                small
                style="z-index:100; margin-bottom: 80px; margin-left: -54px;"
                @click="dialogLogGuideVideo = true"
            >
                <v-icon color="primary">mdi-help-circle-outline</v-icon>
            </v-btn>
        </v-col>
        <v-dialog v-model="dialogLogGuideVideo" class="mx-auto" max-width="750">
            <div class="player-container">
                <vue-core-video-player
                    src="https://dev.aittservice.com/api/video/guide_route.mp4"
                ></vue-core-video-player>
            </div>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"

let url = `${process.env.VUE_APP_ROOT_API}/api/`
export default {
    props: ["data_poi"],
    watch: {
        data_poi: function(val) {
            this.subcase_id = val.subcase_id
            this.draggablex = val.draggable
            this.clear_data()
            this.initialize(val.markers.lat, val.markers.lng)
        },
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.subcase_id = this.data_poi.subcase_id
        this.draggablex = this.data_poi.draggable

        setTimeout(() => {
            this.initialize(
                this.data_poi.markers.lat,
                this.data_poi.markers.lng
            )
        }, 1500)
    },
    computed: {
        ...mapState(["snackbar"]),
        ...mapState(["isLoading"]),
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        ...mapMutations(["mutateIsLoading"]),
        initialize(latx, lngx) {
            this.center = { lat: latx, lng: lngx }
            var streetViewService = new google.maps.StreetViewService()
            var STREETVIEW_MAX_DISTANCE = 100
            streetViewService.getPanoramaByLocation(
                this.center,
                STREETVIEW_MAX_DISTANCE,
                (streetViewPanoramaData, status) => {
                    const panorama = new google.maps.StreetViewPanorama(
                        document.getElementById("pano"),
                        {
                            position: this.center,
                            pov: {
                                heading: 34,
                                pitch: 10,
                            },
                            visible: true,
                            disableDefaultUI: true,
                            clickToGo: false,
                        }
                    )
                    // function นี้ทำเผื่อไว้เลื่อนจะได้พิกัด
                    // panorama.addListener("pano_changed", () => {
                    //     this.center = {
                    //         lat: panorama.position.lat(),
                    //         lng: panorama.position.lng(),
                    //     }
                    // })
                }
            )
        },
        usePlace(place) {
            if (this.place) {
                this.chk_poi = true
                var newPostion = {
                    lat: this.place.geometry.location.lat(),
                    lng: this.place.geometry.location.lng(),
                }
                this.form_poi.lat = this.place.geometry.location.lat()
                this.form_poi.lng = this.place.geometry.location.lng()
                this.form_poi.address = this.place.formatted_address
                this.form_poi.name = this.place.name
                this.center = newPostion
                this.markers[0].position = newPostion
                this.place = null
                this.initialize(this.form_poi.lat, this.form_poi.lng)
            }
        },
        setPlace(place) {
            this.place = place
        },
        updateMaker: function(event) {
            this.markers[0].position = {
                lat: event.latLng.lat(),
                lng: event.latLng.lng(),
            }
            this.initialize(event.latLng.lat(), event.latLng.lng())
            const geocoder = new google.maps.Geocoder()
            geocoder.geocode({ latLng: event.latLng }, (result, status) => {
                if (status === google.maps.GeocoderStatus.OK) {
                    this.form_poi.lat = result[0].geometry.location.lat()
                    this.form_poi.lng = result[0].geometry.location.lng()
                    this.form_poi.address = result[0].formatted_address
                    this.form_poi.name = result[0].name
                    this.chk_poi = true
                }
            })
        },
        async save_poi() {
            this.mutateIsLoading()
            await axios
                .post(
                    url + "mileage/save-edit-poi/" + this.subcase_id,
                    this.form_poi,
                    this.tk
                )
                .then((response) => {
                    this.mutateIsLoading()
                    this.clear_data()
                    this.$emit("close_page_poi")
                    this.mutatesnackbar()
                    if (this.snackbar === true) {
                        setTimeout(() => {
                            this.mutatesnackbar()
                        }, 3000)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        clear_data() {
            this.main_data = null
            this.search = null
            this.center = { lat: null, lng: null }
            this.chk_poi = false
            this.form_poi = {
                lat: null,
                lng: null,
                name: null,
                address: null,
                remark: null,
            }
            this.markers = [
                {
                    position: { lat: null, lng: null },
                },
            ]
            this.place = null
        },
    },
    data() {
        return {
            tk: null,
            subcase_id: null,
            main_data: null,
            search: null,
            center: { lat: null, lng: null },
            chk_poi: false,
            form_poi: {
                lat: null,
                lng: null,
                name: null,
                address: null,
                remark: null,
            },
            markers: [
                {
                    position: { lat: null, lng: null },
                },
            ],
            place: null,
            draggablex: null,
            dialogLogGuideVideo: false,
        }
    },
}
</script>
<style scoped>
.fix-das-bb {
    color: rgb(52, 68, 109) !important;
    font-size: 17px;
}
.fix-das-bbb {
    color: rgb(52, 68, 109) !important;
    font-size: 17px;
    font-weight: bold;
}
</style>
